import axiosConfig from "./axiosConfig";

class SosialyService {
  async getAll() {
    try {
      const response = await axiosConfig.get("/sosialy");
      return response.data || [];
    } catch (error) {
      console.error("Error fetching sosialys:", error);
      return [];
    }
  }

  async create(formData) {
    try {
      const response = await axiosConfig.post("/sosialy", formData);
      return response.data;
    } catch (error) {
      console.error(
        "❌ Erreur lors de la création:",
        error.response?.data || error.message
      );
      return Promise.reject(error.response?.data || { message: error.message });
    }
  }

  async update(id, formData) {
    try {
      const response = await axiosConfig.put(`/sosialy/${id}`, formData);
      return response.data;
    } catch (error) {
      console.error(
        "❌ Erreur lors de la mise à jour:",
        error.response?.data || error.message
      );
      return Promise.reject(error.response?.data || { message: error.message });
    }
  }

  async delete(id) {
    try {
      const response = await axiosConfig.delete(`/sosialy/${id}`);
      return response.data;
    } catch (error) {
      console.error(
        "❌ Erreur lors de la suppression:",
        error.response?.data || error.message
      );
      return Promise.reject(error.response?.data || { message: error.message });
    }
  }
}

const SosialyServiceInstance = new SosialyService();
export default SosialyServiceInstance;
